import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { webSocket } from 'rxjs/observable/dom/webSocket';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

import { types as actions, updateTagAction } from '../../reducers/actions';
import { TagService } from '../../services';
import { TagSerializer } from '../../models';
import { AuthService}  from '../../services';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.STREAM_TAGS),
    switchMap(action =>
      TagService.getAssetGroup(action.siteId, store).pipe(
        switchMap(assetGroup => TagService.getWebSocketUrl(assetGroup, store)),
        switchMap(websocketUrl =>
          {
            let t = AuthService.getToken();
            return webSocket(
              `${websocketUrl}?access_token=${t.access_token}`
            )
          }
        ),
        takeUntil(action$.pipe(
          ofType(actions.CLOSE_STREAM_TAGS)
        )),
        map(data => {
          let serializedData = TagSerializer.normalizeStream(data);
          return updateTagAction(serializedData);
        }),
        catchError(retryAuthentication(action$, 'epics/tags/streamTags'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/tags/streamTags.js